import { Project } from '@app/providers/projects';

export class ProjectDialogData {
  projects: Project[];
}
